import React, { Component } from 'react';
import { Col, Container } from 'react-bootstrap';
import { Spinner } from 'reactstrap';

import { verificarEmail } from '../../crud/auth.crud';

export default class ConfirmarEmail extends Component {
    state = {
        loading: true,
        success: false,
        message: '',
    };

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (!token) {
            this.setState({ loading: false, success: false, message: 'Token de verificação não encontrado.' });
            return;
        }

        verificarEmail(token)
            .then((res) => {
                this.setState({ loading: false, success: true, message: res.data.message });
            })
            .catch(({ response }) => {
                this.setState({ loading: false, success: false, message: response?.data?.message || 'Não foi possível confirmar seu e-mail.' });
            });
    }

    render() {
        const { loading, success, message } = this.state;

        return (
            <Container fluid className="d-flex p-0 loginContainer">
                <Col className="p-0 d-none d-lg-block" lg={6}>
                    <div style={{ backgroundImage: `url('/images/login/login-left.png')`, height: '100vh', width: '100%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }} />
                </Col>

                <Col xs={12} sm={12} md={12} lg={6} className="formSide d-flex justify-content-center">
                    <Col md={9}>
                        <img src="/images/logo-color.png" width="auto" height="20" alt="Logo" />

                        <div className="boxLogin">
                            {loading ? (
                                <>
                                    <h1>Confirmando seu e-mail...</h1>
                                    <Spinner className="mt-4" />
                                </>
                            ) : (
                                <>
                                    <h1>{success ? 'E-mail confirmado!' : 'Não foi possível confirmar'}</h1>
                                    <p>{message}</p>
                                    <div className="buttonContainer mt-4">
                                        <a className="btn btn-primary btn-elevate kt-login__btn-primary" href="/">Voltar para o início</a>
                                    </div>
                                </>
                            )}
                        </div>
                    </Col>
                </Col>
            </Container>
        );
    }
}
